import React from "react";

const MediaCarousel = ({ isOpen, closeCarousel, mediaType, memoryData, currentMediaIndex, prevMedia, nextMedia }) => {

    if (!isOpen) return null;

    const buttonStyle = {
        position: "absolute",
        top: "20px",
        right: "20px",
        backgroundColor: "transparent",
        border: "none",
        fontSize: "24px",
        color: "white",
        cursor: "pointer",
        zIndex: 1051
    };

    const navButtonStyle = {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        backgroundColor: "transparent",
        border: "none",
        fontSize: "24px",
        color: "white",
        cursor: "pointer",
        zIndex: 1051
    };

    const renderMedia = () => {
        
        switch (mediaType) {
            case "image":
                return (
                    <img
                        src={memoryData.gallery[currentMediaIndex].media}
                        alt={memoryData.gallery[currentMediaIndex].name}
                        style={{ maxWidth: "80%", maxHeight: "80%" }}
                    />
                );
            case "video":
                return (
                    <video controls style={{ maxWidth: "80%", height: "auto" }}>
                        <source src={memoryData.video?.media} type="video/mp4" />
                    </video>
                );
            case "pdf":
                return (
                    <iframe
                        src={memoryData.pdf?.media}
                        style={{ width: "80%", height: "80%" }}
                        title="PDF Viewer"
                    ></iframe>
                );
            default:
                return null;
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                zIndex: 1050,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}
        >
            <button onClick={closeCarousel} style={buttonStyle}>
                ✕
            </button>

            {renderMedia()}

            {mediaType === "image" && memoryData?.gallery.length > 1 && (
                <>
                    <button onClick={prevMedia} style={{ ...navButtonStyle, left: "20px" }} aria-label="Previous media">
                        ←
                    </button>
                    <button onClick={nextMedia} style={{ ...navButtonStyle, right: "20px" }} aria-label="Next media">
                        →
                    </button>
                </>
            )}
        </div>
    );
};

export default MediaCarousel;
